import zionDebug from '@fs/zion-debug'
import { doFetchPost, getXRequestId } from './apiService'
import { ALL_PLACE_PERMISSIONS } from './placePermissionHelpers'

const debug = zionDebug('standards:places:apiService')

type Permissions = Record<string, boolean>

type PermissionsError = {
  err: {
    status: number
  }
}

/**
 * Get authorization for multiple permissions within a context.
 * @return CAS Authorization object.
 */
export async function getPlacePermissions(): Promise<Permissions | PermissionsError> {
  const context = 'place'

  // Create AuthorizationBatchRequest format for new CAS v2 endpoint
  const authorizationBatchRequest = {
    authorizationRequests: [
      {
        context,
        permissions: ALL_PLACE_PERMISSIONS,
      },
    ],
  }

  const editAuthUrl = '/service/ident/cas/cas-public-api/authorizations'
  let resp
  try {
    resp = await doFetchPost(
      editAuthUrl,
      authorizationBatchRequest,
      {
        headers: {
          accept: 'application/cas-v2+json',
          'Content-Type': 'application/json',
          'X-Request-ID': getXRequestId(),
        },
      },
      { expectedStatuses: [400] }
    )
  } catch (err: unknown) {
    debug('Error while checking CAS permissions:', err)
    return {
      err: {
        status:
          (err as { response?: { status?: number }; status?: number })?.response?.status ||
          (err as { status?: number })?.status ||
          500,
      },
    }
  }
  debug('resp checking CAS permissions:', resp)

  const authorizationResult = resp.data.results[0]
  const permissions: Permissions = {}

  // Set authorized permissions to true
  authorizationResult.authorizedPermissions.forEach((perm: string) => {
    permissions[perm] = true
  })

  // Set unauthorized permissions to false
  authorizationResult.unauthorizedPermissions.forEach((perm: string) => {
    permissions[perm] = false
  })
  debug('permissions:', permissions)

  return permissions
}
